import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ApplicationSteps } from "../../../../models/applications.models";
import { ApplicationSectionBaseComponent } from "../../../application-section-base/application-section-base.component";
import { AuthService } from "../../../../../services/auth.service";

import { CasingTypeModel, FormationModel, DrillingEquipmentModel } from "../../../../../form-controls/components/new-casing-plan/models/casing-plan.model";


@Component({
    selector: 'app-construction',
    templateUrl: './construction.component.html',
    styleUrls: ['./construction.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss'],
    standalone: false
})
export class ConstructionComponent extends ApplicationSectionBaseComponent implements OnInit {


    readonly step: ApplicationSteps = ApplicationSteps.WellConstruction;

    @Input() casingTypes: CasingTypeModel[] = [];

    private _drillingEquipment: DrillingEquipmentModel[];

    get drillingEquipment(): DrillingEquipmentModel[] {
        if (this._drillingEquipment == null) return [];
        return this._drillingEquipment.filter(d => this._validToolTypes.includes(d.code) || d.code == "");
    }

    @Input() set drillingEquipment(value: DrillingEquipmentModel[]) {
        this._drillingEquipment = value;
    }

    private _formations: FormationModel[] = [];

    get formations(): FormationModel[] {
        return this._formations;
        
    }

    @Input() set formations(models: FormationModel[]) {
        models.forEach(m => this._formations.push(m));
        if (models.find(f => f.code == "") == null) {
            var select = new FormationModel();
            select.code = "";
            select.definition = "";
            this._formations.unshift(select);
        }
    }

    _validToolTypes = [ "CNC", "CT", "RTA", "RTAF", "RTF", "SERV"];

    constructor(_auth: AuthService) { super(_auth); }

    ngOnInit() {
    }

    getFieldName(code: string, section: string): string {
        return `construction|${code}|${section}`;
    }


    toggleOpen(): void {
        if (this.step == this.activeStep || !this.isOpen) super.toggleOpen();
        this.openChanged.emit(this.step);
    }
}
